import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() { }

  set(key: string, value: string): Observable<void> {
    return from(Preferences.set({ key, value }));
  }

  get(key: string): Observable<string | null> {
    return from(Preferences.get({ key })).pipe(
      map(result => result.value)
    );
  }

  remove(key: string): Observable<void> {
    return from(Preferences.remove({ key }));
  }
}
